import { render } from "./MenuBar.vue?vue&type=template&id=4a501398&scoped=true"
import script from "./MenuBar.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuBar.vue?vue&type=script&setup=true&lang=js"

import "./MenuBar.vue?vue&type=style&index=0&id=4a501398&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.22_typescript@5.8.3__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a501398"],['__file',"src/components/MenuBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a501398"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a501398', __exports__)) {
    api.reload('4a501398', __exports__)
  }
  
  module.hot.accept("./MenuBar.vue?vue&type=template&id=4a501398&scoped=true", () => {
    api.rerender('4a501398', render)
  })

}


export default __exports__